{
    "coordinates": [
        49.97350392228259,
        6.052610171828547
    ],
    "tooltip": "Consthum Lagerstätte",
    "title": "Consthum Lagerstätte",
    "country": "Luxembourg",
    "period": "Devonian",
    "alt": "TODO"
}
